<template>
  <div id="basketballLeague_teamDeail_matchSchedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <div :class="scrollDomClassName">
          <schedule_match_list
            v-if="matchList && matchList.length > 0"
            :currCid="currCid"
            :currSid="currSid"
            :currThemeObj="currThemeObj"
            :data="matchList"
            :detailPathName="detailPathNameArr"
            :localStorageSaveDate="currStageMatchDate"
            :themeClass="'onlyDisplay'"
            :matchModeObj="{
              mode: 'BasketballLeague',
            }"
          />
        </div>
        <cup_notData v-if="noData" className="relativePtb60"></cup_notData>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_teamDetail_seasonList,
  https_teamDetail_teamSchedule,
} from '@api/platfrom_basketball_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'basketballLeague_teamDeail_matchSchedule',
  components: {
    marathon_select_opt,
    BackTop,
    schedule_match_list,
    cup_notData,
  },
  mixins: [cup_base_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      currStageMatchDate: '', //字段无用
      currStageSeason: '',
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      seasonArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['value', 'name'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      showBackTop: false,
      detailPathNameArr: [
        {
          pathName: 'scheduleDetailPreMatch',
          matchStatus: '1',
        },
        {
          pathName: 'scheduleDetailPreMatch',
          matchStatus: '5',
        },
        {
          pathName: 'scheduleDetailAnalysis',
          matchStatus: 'all',
        },
      ],
    }
  },
  created() {
    console.debug('league_schedule init ')
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.detailPathNameArr.forEach((item) => {
        item.pathName = `${item.pathName}_${moduleRouteNameEn}` // teamDetailPlayerList_CBA
      })
    }
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      return this.matchList && this.matchList.length === 0
    },
  },
  methods: {
    async init() {
      console.debug('this.currGroup league_schedule:', this.currGroup)
      this.query = this.$route.query
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getSeasonList()
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getScheduleMatchList()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      console.debug('this.scrollAreaDom:', this.scrollAreaDom)
      this.beforeScrollTop = 0
      // this.threshold = 5
      // this.DIRECTION_ENUM = {
      //   DOWN: 'down',
      //   UP: 'up',
      // }

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      console.debug('this.scrollAreaDom:', this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    scrollListenerEvent() {
      console.debug('scrollListenerEvent')
      const scrollTop = this.scrollAreaDom.scrollTop

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getSeasonList() {
      await https_teamDetail_seasonList(this.axiosBaseUrl, this.$axios, {
        tid: this.query.tid,
      })
        .then((response) => {
          const res = response.data
          console.debug('getSeasonList res:', res)
          if (res.status === 0) {
            this.seasonArr = res.data
              ? res.data.map((item) => {
                  return {
                    value: item.seasonId + '',
                    name: item.seasonAbbr,
                  }
                })
              : []
            if (this.seasonArr.length > 0) {
              this.currStageSeason = this.seasonArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list)
      if (list && list.length > 0) {
        this.matchList = list.map((item) => {
          let newItem = item
          newItem.gameDate = newItem.matchDate
          newItem.gameTime = newItem.matchTime
          newItem.chooseId = item.matchId
          newItem.isChooseFlag = false
          return newItem
        })
      } else {
        this.matchList = []
      }
    },
    async getScheduleMatchList() {
      let params = {
        sid: this.currStageSeason,
        tid: this.query.tid,
      }
      console.debug(params)
      await https_teamDetail_teamSchedule(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.matchList = []
              this.matchLabelArr = []
              this.curMatchLabelFixedIcon = null
              this.initScroll()
              this.computedMatchList(res.data)
            } else {
              console.debug('暂无数据')
            }
            console.debug('暂无数据 11:', this.matchList, this.matchList.length)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketballLeague_teamDeail_matchSchedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }
  .selectTab_area {
    margin-top: 2.778vw;
    width: 100%;
    height: 2.778vw;
  }
  .teamTable {
    padding: 1.388vw 0 2.778vw 0;
  }
}
</style>
